import * as PropTypes from 'prop-types';
// In a strictly typescript environment, PropTypes are mostly redundant. However, they still provide safety when this
// project is consumed by javascript projects
export var propTypes = {
    checkboxId: PropTypes.string,
    onChange: PropTypes.func,
    isChecked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    overflowTooltip: PropTypes.bool,
    inputAttributes: PropTypes.object
};
//# sourceMappingURL=types.js.map